import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AssignUserApi } from '../../shared/api/AssignUserApi';
import { RootState } from '../store';

interface User {
    id: number;
    name: string;
}

interface UsersState {
    users: User[];
    projectData: ProjectData | null;
}

const initialState: UsersState = {
    users: [],
    projectData: null,
};

interface milestoneUsers {
    id: number;
    email: string;
    name: string;
    profilePhoto: string;
    roleId: number;
    roleName: string;
}

interface ProjectMilestones {
    id: number;
    milestoneName: string;
    startDate: string;
    endDate: string;
    approvalDate: string;
    sequence: number;
    userName: string;
    milestoneKey: string;
    description: string;
    milestoneUsers: milestoneUsers[];
}

interface Project {
    id: number;
    name: string;
    deadlineDate: string;
    completionDate: string | null; 
    requestType: string;
    productType: string;
    priorityStatus: string;
    createdDate: string | null;
    projectStatus: string;
    key: string;
    tentativeCost: any;
    deliverableCount?: number | null;
}

interface ProjectData {
    project: Project;
    projectMilestones: ProjectMilestones[];
}

const usersSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {
        setUsers: (state, action: PayloadAction<User[]>) => {
            state.users = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
        .addMatcher(
            AssignUserApi.endpoints.getUsers.matchFulfilled,
            (state, action) => {
                if (action.payload) {
                    state.projectData = action.payload as ProjectData;
                }
            }
        )
    },
});

export const { setUsers } = usersSlice.actions;
export const allProjectData = (state: RootState) => state.users.projectData;
export default usersSlice.reducer;
